import getTutorial from './tutorial'
import constants from './constants'

export let getHelp = getTutorial
export let pages = constants
